var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{ref:"svg",staticClass:"spinner-morph-c",attrs:{"viewBox":"0 0 120 134","role":"img","aria-label":"Loading"}})
}
var staticRenderFns = []

export { render, staticRenderFns }